var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heading-container"},[_c('div',{staticClass:"col-left"},[_vm._v(" "+_vm._s(_vm.label || "-")+" ")]),_c('div',{staticClass:"col-right"},[_c('div',[_vm._v(_vm._s(_vm.user || "-"))]),_c('div',{staticClass:"date-value"},[_vm._v(_vm._s(_vm.displayDate))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }